module.exports = __webpack_public_path__ + "img/p-two-step-07.655f4e53.png";